import { render, staticRenderFns } from "./DisconnectionAlert.vue?vue&type=template&id=5ff6c84a&"
import script from "./DisconnectionAlert.vue?vue&type=script&lang=js&"
export * from "./DisconnectionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports